<script>
export default {
    name: "OrderPrint",

    data() {

        return {
            order: {},
            orderItems: [],
            printPrices:0,
        };
    },

    computed: {

        totalExlusiveTax() {
            if(!this.orderItems.length) return 0;

            return this.orderItems.map(item => item.lineTotal ? parseFloat(item.lineTotal) : 0)
                .reduce((sum, lineTotal) => sum + lineTotal);
        },

        totalDiscount() {
            if(!this.orderItems.length) return 0;

            return this.orderItems.map(item => item.lineDiscount ? parseFloat(item.lineDiscount) : 0)
                .reduce((sum, discount) => sum + discount);
        },

        totalTax() {
            if(!this.orderItems.length) return 0;

            return this.orderItems.map(item => item.tax ? parseFloat(item.tax) : 0)
                .reduce((sum, tax) => sum + tax);
        },

        netTotal() {

            return this.totalExlusiveTax - this.totalTax;
        },
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchRequisition(), this.fetchRequisitionItems(), ]).then(() => {
            this.$root.loading = false;
            this.printwithprice();
            setTimeout(() => {
                window.print();
            }, 200);
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchRequisitionItems() {
            let url = `Inventory/GetInventoryRequisitionItems`;
                url += `?RequistionNo=${this.$route.params.orderNo}`;

            return this.$http.get(url).then(({ data }) => {
                this.orderItems = data;
            }).catch(() => {});
        },

        fetchRequisition() {

            let url = `Inventory/GetSpecifictRequisiton`;
                url += `?RequistionNo=${this.$route.params.orderNo}`;

            return this.$http.get(url).then(({ data }) => {
                if(data.length) {
                    this.order = {
                        requisitionID: data[0].requisitionID,
                        departmentId: data[0].departmentId,
                        department: data[0].department,
                        fromStoreId: data[0].fromStoreId,
                        fromStore: data[0].fromStore,
                        toStoreId: data[0].toStoreId,
                        toStore: data[0].toStore,
                        supplier: data[0].supplier,
                        requsitionTypeId: data[0].requisitionTypeID,
                        requsitionType: data[0].requisitionType,
                        txnDate: this.$moment(data[0].trxDate).format(`YYYY-MM-DD`),
                        userName: data[0].userName,
                        approved: data[0].approved,
                    };
                }
            }).catch(() => {});
        },
        printwithprice() {
      
            this.printPrices=parseInt(this.$route.query.price);
        } 
    }
}
</script>
<template>
<div class="w-full flex flex-wrap">
    <tail-address-header></tail-address-header>
    <div class="w-full flex flex-wrap p-2 my-2">
        <div class="w-full p-1 mb-2 text-center">
            <h5 class="font-bold text-lg">
                {{ order.requsitionType }}</h5>
        </div>
        <div class="w-full p-1 mb-2 text-center">
            <h5 class="font-bold">
                Order No: {{ $route.params.orderNo }}</h5>
        </div>
        <div class="w-full p-1 mb-2 text-center">
            <h5 class="font-bold uppercase">
                {{ order.approved ? `Approved` : `Pending` }}</h5>
        </div>
        <div class="w-1/3 p-1">
            <h5 class="font-medium">
                Store From: {{ order.fromStore }}</h5>
        </div>
        <div class="w-1/3 p-1" v-if="order.requsitionTypeId === 1">
            <h5 class="font-medium">
                Store To: {{ order.toStore }}</h5>
        </div>
        <div class="w-1/3 p-1" v-if="order.requsitionTypeId === 2">
            <h5 class="font-medium">
                Supplier: {{ order.supplier || `-` }}</h5>
        </div>
    </div>
    <div class="w-full overflow-visible">
        <table class="table">
            <thead class="text-xs">
                {{printPrices}}{{order.requsitionTypeId}}
                <tr>
                    <th class="p-tiny border">Id</th>
                    <th class="p-tiny border">Item</th>
                    <th class="p-tiny border">Qty</th>
                    <th class="p-tiny border">W/P</th>
                    <th class="p-tiny border">Bonus</th>
                    <th class="p-tiny border" v-if="order.requsitionTypeId === 1||printPrices===1">Cost</th>
                    <th class="p-tiny border" v-if="order.requsitionTypeId === 1||printPrices===1">Tax</th>
                    <th class="p-tiny border" v-if="order.requsitionTypeId === 1||printPrices===1">Discount</th>
                    <th class="p-tiny border" v-if="order.requsitionTypeId === 1||printPrices===1">Total</th>
                </tr>
            </thead>
            <tbody class="text-xs">
                <tr v-for="orderItem in orderItems" :key="orderItem.requisitionDetailID">
                    <td class="p-tiny">{{ orderItem.requisitionDetailID }}</td>
                    <td class="p-tiny">{{ orderItem.item }}</td>
                    <td class="p-tiny">{{ orderItem.quantity }}</td>
                    <td class="p-tiny">-</td>
                    <td class="p-tiny">{{ orderItem.bonus | numberFormat }}</td>
                    <td class="p-tiny" v-if="order.requsitionTypeId === 1||printPrices===1">
                        {{ orderItem.price | numberFormat }}</td>
                    <td class="p-tiny" v-if="order.requsitionTypeId === 1||printPrices===1">
                        {{ orderItem.tax | numberFormat }}</td>
                    <td class="p-tiny" v-if="order.requsitionTypeId === 1||printPrices===1">
                        {{ orderItem.lineDiscount | numberFormat }}</td>
                    <td class="p-tiny" v-if="order.requsitionTypeId === 1||printPrices===1">
                        {{ orderItem.lineTotal | numberFormat }}</td>
                </tr>
                <tr v-if="order.requsitionTypeId === 1||printPrices===1" class="text-xs">
                    <th colspan="6" class="p-1"></th>
                    <th class="p-1" colspan="2">Total Discount:</th>
                    <th class="p-1">{{ totalDiscount | numberFormat }}</th>
                </tr>
                <tr v-if="order.requsitionTypeId === 1||printPrices===1" class="text-xs">
                    <th colspan="6" class="p-1"></th>
                    <th class="p-1" colspan="2">Total Exclusive Tax:</th>
                    <th class="p-1">{{ totalExlusiveTax | numberFormat }}</th>
                </tr>
                <tr v-if="order.requsitionTypeId === 1||printPrices===1" class="text-xs">
                    <th colspan="6" class="p-1"></th>
                    <th class="p-1" colspan="2">Total Tax:</th>
                    <th class="p-1">{{ totalTax | numberFormat }}</th>
                </tr>
                <tr v-if="order.requsitionTypeId === 1||printPrices===1" class="text-xs">
                    <th colspan="6" class="p-1"></th>
                    <th class="p-1" colspan="2">Total:</th>
                    <th class="p-1">{{ netTotal | numberFormat }}</th>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</template>
